import React, { ReactNode } from "react";

interface CreditCardBaseProps {
  icon: ReactNode;
  title: string;
  description: string;
  price: string;
  priceLabel: string;
  rightContent?: ReactNode;
  footerAlert?: ReactNode;
}

export const CreditCardBase: React.FC<CreditCardBaseProps> = ({
  icon,
  title,
  description,
  price,
  priceLabel,
  rightContent,
  footerAlert,
}) => {
  return (
    <div className="flex w-full flex-col overflow-hidden rounded-3xl border border-solid border-dark-100 bg-white">
      <div className="flex flex-col gap-10 p-8">
        <div className="flex items-start justify-between gap-10">
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              {icon}
              <span className="font-secondary text-xl font-semibold text-dark">
                {title}
              </span>
            </div>
            <span className="mt-2 max-w-[700px] font-secondary text-sm leading-[21px] tracking-[0.14px] text-dark-700">
              {description}
            </span>
          </div>
          {rightContent}
        </div>

        <div className="flex items-center gap-2">
          <span className="font-secondary text-[24px] leading-[30px] font-medium tracking-[-0.2px] text-dark">
            {price}
          </span>
          <span className="font-secondary text-sm leading-[21px] tracking-[-0.14px] text-dark-700">
            {priceLabel}
          </span>
        </div>
      </div>
      {footerAlert}
    </div>
  );
};
